<template>
  <Page :title="title" :back-to="`/admin/clients/${id}`">
    <v-container fluid>
      <ClientsForm
        @cancel="handleCancel"
        @submit="updateClient"
        ref="form"
        width="650"
        :closeable="false"
        class="mx-auto"
      />
    </v-container>
  </Page>
</template>

<script>
import Page from "@/components/layout/Page";
import Service from "@/services/ClientsService";
import ClientsForm from "@/components/forms/ClientsForm";

const service = new Service();

export default {
  components: { Page, ClientsForm },

  props: {
    id: [Number, String]
  },

  data() {
    return {
      service,
      title: ""
    };
  },

  methods: {
    async getData() {
      const client = await this.service.show(this.id);
      this.$refs.form.init(client);
      this.title = client.name;
    },
    async updateClient(client) {
      this.$refs.form.loading = true;

      try {
        await this.service.update(client, this.id);
        this.$router.replace(`/admin/clients/${this.id}`);
        this.getData();
      } catch (error) {
        console.error(error);
      }
    },
    handleCancel() {
      if (!confirm("Tem certeza?")) return;

      this.$router.replace(`/admin/clients/${this.id}`);
    }
  },

  created() {
    this.getData();
  }
};
</script>
